import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Login from './UserComponents/Login/Login';
import AppLayout from './UserComponents/Layout/AppLayout';
import Dashboard from './UserComponents/Dashboard/Dashboard';
import NewBillContainer from './UserComponents/Billing/NewBillContainer';
import BillDetails from './UserComponents/Billing/BillDetails';
import InterCompanyTranfer from './UserComponents/Billing/InterCompanyTranfer';
import IntercompanyBillViewer from './UserComponents/Billing/IntercompanyBillViewer';
import BillViewer from './UserComponents/Billing/BillViewer';
import CustomerDueList from './UserComponents/Billing/CustomerDueList';
import UserCashCollection from './UserComponents/CashCollectionReport/UserCashCollection';
import Salary from './UserComponents/Salary/Salary';
import InventoryAdd from './UserComponents/Inventory/InventoryAdd';
import FilterPage from './UserComponents/Inventory/FilterPage';
import FilterSalesPage from './UserComponents/SalesReport/FilterSalesPage';
import CustomerOrder from './UserComponents/OrderBook/CustomerOrder';
import OrderView from './UserComponents/OrderBook/OrderView';
import AddItemStock from './UserComponents/Inventory/AddItemStock';
import AddInventoryItem from './UserComponents/Inventory/AddInventoryItem';
import PurchaseOrderBook from './UserComponents/OrderBook/PurchaseOrderBook';
import BarcodePrintPage from './UserComponents/Billing/BarcodePrintPage';
import Bill from './UserComponents/Billing/Bill';
import { API_BASE_URL } from './UserComponents/Config.js';
import StoreComponent from './UserComponents/Store/StoreComponent';
import StoreLogin from './UserComponents/Store/StoreLogin';
import Invoice from './UserComponents/Invoice/Invoice';
import SchoolSalesReport from './UserComponents/SalesReport/SchoolSalesReport';
import SalesReportGraph from './UserComponents/SalesReport/SalesReportGraph';
import ExchangeBill from './UserComponents/Billing/ExchangeBill.js';
import './App.css';
// Global styles that were previously pulled in through MainComponent's imports
import './UserComponents/Billing/ItemCodeFetcher.css';
import TransactionView from './UserComponents/Transactions/TransactionView.js';
import Transaction from './UserComponents/Transactions/Transaction.js';
import ExcelDownloader from './UserComponents/Billing/ExcelDownloader.js';
import UpdateItems from './UserComponents/Inventory/UpdateItems.js';
import Cloth from './UserComponents/admin/cloth/Cloth.jsx';
import InfoPage from './UserComponents/InfoPage/InfoPage.js';
import NewBillContainerMobile from './UserComponents/Billing/NewBillContainerMobile.js';
import ItemUpdateHistory from './UserComponents/Inventory/ItemUpdateHistory.js';
import StockView from './UserComponents/Inventory/StockView.js';
import BillModificationHistory from './UserComponents/Billing/BillModificationHistory.js';
import GroupManager from './UserComponents/Inventory/GroupManager.js';
import Admin from './UserComponents/admin/dashboard/Admin.jsx';
import PrintBillModalVN from './UserComponents/print/PrintBillModalVN.js';
import Analytics from './UserComponents/Dashboard/Analytics.js';
import ClothList from './UserComponents/admin/cloth/ClothList.jsx';


function App() {
  const [userData, setUserData] = useState(null);
  const [token, setToken] = useState(null);
  const [serverOffline, setServerOffline] = useState(false);
  const[userLoginStatus,setLoginStatus]=useState(false);
   const [openModal, setOpenModal] = useState(false);

  const saveUserData = (data, token,storeConfig) => {
    setUserData(data);
    setToken(token);

    sessionStorage.setItem('user', JSON.stringify(data));
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('storeConfig', JSON.stringify(storeConfig));

  };


  useEffect(() => {

    if(!userLoginStatus)
    {
      setUserData(null);
      sessionStorage.removeItem('user'); // Remove user data from session storage
      sessionStorage.removeItem('token'); // Remove user data from session storage
      return;
    }
    const savedUserData = sessionStorage.getItem('user');
    const savedToken = sessionStorage.getItem('token');

    if (savedUserData && savedToken) {
      setUserData(JSON.parse(savedUserData));
      setToken(savedToken);
    }
  }, [userLoginStatus]);

  useEffect(() => {
    const checkServerStatus = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/user/health-check`);
        if (response.ok) {
          setServerOffline(false);
        } else {
          setServerOffline(true);
        }
      } catch (error) {
        setServerOffline(true);
      }
    };

    checkServerStatus();
    const interval = setInterval(checkServerStatus, 20000); // Check every 20 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <Router>
    <div className="App">
      {serverOffline && (
        <div className="offline-dialog">
          <p>Server is offline. Please check your connection.</p>
        </div>
      )}
    <Routes>
          {/* Public pages */}
          <Route path="/store/login" element={<StoreLogin />} />
          <Route path="/store/dashboard" element={<StoreComponent />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/exchange" element={<ExchangeBill />} />
          <Route path="/download" element={<ExcelDownloader />} />
          <Route path="/update" element={<UpdateItems />} />
          <Route path="/info" element={<InfoPage />} />

          {!userData ? (
             <Route path="*" element={<Login setUserData={saveUserData} />} />
          ) : (
            <>
              {/* Pages shown inside the top bar + sidebar layout.
                  Sidebar links live in UserComponents/Layout/Sidebar.js */}
              <Route path="/" element={<AppLayout userData={userData} />}>
                <Route index element={<Dashboard />} />

                {/* Billing */}
                <Route path="/bill/new" element={<NewBillContainer userData={userData} />} />
                <Route path="/returns" element={<BillDetails userData={userData} />} />
                <Route path="/inter-company" element={<InterCompanyTranfer userData={userData} />} />
                <Route path="/inter-company/bills" element={<IntercompanyBillViewer />} />
                <Route path="/bills/recent" element={<BillViewer />} />
                <Route path="/customers/due" element={<CustomerDueList />} />
                <Route path="/daily-cash" element={<Transaction />} />

                {/* Orders */}
                <Route path="/orders/new" element={<CustomerOrder />} />
                <Route path="/orders" element={<OrderView />} />
                <Route path="/purchase-orders" element={<PurchaseOrderBook />} />

                {/* Inventory */}
                <Route path="/stock" element={<FilterPage />} />
                <Route path="/inventory/add-quantity" element={<AddInventoryItem />} />
                <Route path="/inventory/items" element={<InventoryAdd />} />

                {/* Reports */}
                <Route path="/cash-collection" element={<UserCashCollection />} />
                <Route path="/reports/sales" element={<FilterSalesPage />} />
                <Route path="/reports/school" element={<SchoolSalesReport />} />
                <Route path="/salary" element={<Salary />} />
              </Route>

              {/* Full-screen pages */}
              <Route path="/barcode" element={<BarcodePrintPage />} />
              <Route path="/admin/dashboard" element={<Admin />} />
              <Route path="/mobile/bill" element={<NewBillContainerMobile />} />
              <Route path="/transaction" element={<Transaction />} />
              <Route path="/cloth/add" element={<Cloth />} />
              <Route path="/cloth/update" element={<ClothList />} />
              <Route path="/view/itemUpdateHistory" element={<ItemUpdateHistory />} />
              <Route path="/stock/bulkUpdate" element={<StockView />} />
              <Route path="/bill/updateHistory" element={<BillModificationHistory />} />
              <Route path="/groupManager" element={<GroupManager />} />
              <Route path="/inventory/analytics" element={<Analytics />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
